import React from 'react';

export class TeamMember extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  render () {
    return (
      <div className="team-member">
        <div className="team-member__name">{ this.props.name }</div>
        <div className="team-member__title">{ this.props.title }</div>
        <div className="team-member__phone">{ this.props.phoneNumber }</div>
        <a className="team-member__email" href={`mailto:${ this.props.email }`}>{ this.props.email }</a>
      </div>
    );
  }
}
